import { useSetAtom } from 'jotai';
import { useCallback } from 'react';

import { DataChannelSessionIntentionEditedMessage } from '../../video-sdk';
import { inSessionPatientInformationAtom } from '../state';

export function useHandleReceivedSessionIntentionEditedCallback() {
  const setInSessionPatientInformation = useSetAtom(inSessionPatientInformationAtom);

  return useCallback(
    async (message: DataChannelSessionIntentionEditedMessage) => {
      const patientShortId = message.sender.entityId;
      const { editedAt } = message.sessionIntention;

      setInSessionPatientInformation((prev) => {
        if (!prev || prev.patientShortId !== patientShortId) return prev;

        return {
          ...prev,
          intentionEditedAt: editedAt,
        };
      });
    },
    [setInSessionPatientInformation],
  );
}
